import { useCallback, type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { parentHelperActions } from 'pages/ParentHelper/store';
import { ActionSection as SharedActionSection } from 'shared/components/Disclaimer';
import { Button } from 'shared/components/buttons/Button';

export const ActionSection: FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const enableParentHelper = useCallback(() => {
    dispatch(parentHelperActions.enable());
  }, [dispatch]);

  return (
    <SharedActionSection>
      <Button
        sx={{ borderRadius: '24px' }}
        variant="contained"
        onClick={enableParentHelper}
      >
        {t('pages.parentHelper.disclaimer.enableParentHelperButton')}
      </Button>
    </SharedActionSection>
  );
};
